import Navbar from "./Navbar";
import "./App.css";
import HeroSection from "./HeroSection";
import Contact from "./Contact";
import Projects from "./Projects";
import About from "./About";
import { Skills } from "./Skills";

function App() {
  return (
    <>
      <Navbar />
      <HeroSection />
      <About />
      <Skills />
      <Projects />
      <Contact />
    </>
  );
}

export default App;
